import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ['subtotal', 'donation', 'fees', 'total', 'itemCount', 'emptyMessage', 'cartContent']
  static values = {
    updateUrl: String
  }

  connect() {
    super.connect()
    
    // Listen for cart update events
    document.addEventListener('cartUpdated', this.handleCartUpdate.bind(this))
    document.addEventListener('itemAdded', this.handleItemAdded.bind(this))
  }

  disconnect() {
    document.removeEventListener('cartUpdated', this.handleCartUpdate.bind(this))
    document.removeEventListener('itemAdded', this.handleItemAdded.bind(this))
  }

  handleCartUpdate(event) {
    const data = event.detail
    this.updateTotals(data)
  }

  handleItemAdded(event) {
    const data = event.detail
    this.updateTotals(data)
    
    // Show success animation
    if (this.hasItemCountTarget) {
      this.itemCountTarget.classList.add('pulse')
      setTimeout(() => {
        this.itemCountTarget.classList.remove('pulse')
      }, 600)
    }
  }

  updateTotals(data) {
    if (data.cart) {
      // Update subtotal
      if (this.hasSubtotalTarget) {
        this.subtotalTarget.textContent = `$${this.formatMoney(data.cart.subtotal)}`
      }
      
      // Update donation
      if (this.hasDonationTarget) {
        this.donationTarget.textContent = `$${this.formatMoney(data.cart.donation_amount)}`
      }
      
      // Update fees
      if (this.hasFeesTarget) {
        this.feesTarget.textContent = `$${this.formatMoney(data.cart.fee_coverage_amount)}`
      }
      
      // Update total
      if (this.hasTotalTarget) {
        this.totalTarget.textContent = `$${this.formatMoney(data.cart.total)}`
      }
      
      // Update item count
      if (this.hasItemCountTarget) {
        this.itemCountTarget.textContent = data.cart.item_count || '0'
      }
      
      // Show/hide empty message
      this.updateEmptyState(data.cart.item_count || 0)
    }
  }

  updateEmptyState(itemCount) {
    const hasItems = itemCount > 0
    
    if (this.hasEmptyMessageTarget) {
      if (hasItems) {
        this.emptyMessageTarget.classList.add('hide')
      } else {
        this.emptyMessageTarget.classList.remove('hide')
      }
    }
    
    if (this.hasCartContentTarget) {
      if (hasItems) {
        this.cartContentTarget.classList.remove('hide')
      } else {
        this.cartContentTarget.classList.add('hide')
      }
    }
  }

  formatMoney(amount) {
    return parseFloat(amount || 0).toFixed(2)
  }

  refreshTotals() {
    fetch(this.updateUrlValue, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      this.updateTotals(data)
    })
    .catch(error => {
      console.error('Error refreshing cart totals:', error)
    })
  }
}